'use client';

import { AccountOrder } from '../types';

interface ReduceOnlyCellProps {
	order: AccountOrder;
}

const EMPTY_VALUE = <span className="text-text-tertiary">-</span>;

export function ReduceOnlyCell({ order }: ReduceOnlyCellProps) {
	return order.reduceOnly ? <span>Yes</span> : EMPTY_VALUE;
}
